import { Injectable, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { WebrtcMeshService } from './webrtc-mesh.service';
// import { YourWebSocketService } from './your-websocket.service';

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class IosBackgroundService {
  private isAudioSessionActive = false;

  constructor(
    private platform: Platform,
    private ngZone: NgZone,
    private webrtcMeshService: WebrtcMeshService,
    // private websocketService: YourWebSocketService
  ) { }

  /**
   * Start background audio session and (re)connect mesh/network.
   */
  public async startBackgroundSession(sessionType: 'audio' | 'counting' | 'both' = 'both') {
    if (!this.platform.is('ios')) return;
    if (this.isAudioSessionActive) return;

    // Start a silent audio session if not already active
    this.ngZone.runOutsideAngular(() => {
      if (window.cordova && window.cordova.plugins && window.cordova.plugins.backgroundMode) {
        window.cordova.plugins.backgroundMode.enable();
        window.cordova.plugins.backgroundMode.setDefaults({
          title: 'Aforo Mesh',
          text: sessionType === 'audio'
            ? 'Audio streaming is running in the background'
            : sessionType === 'counting'
              ? 'Counting session is running in the background'
              : 'Audio and counting are running in the background'
        });
        this.isAudioSessionActive = true;
        console.log('[IosBackgroundService] Background mode enabled');
      }
    });

    // Optionally, (re)connect your mesh or WebSocket here
    // await this.websocketService.connect();
    // await this.webrtcMeshService.initMesh(currentEventId, isCreator);
  }

  /**
   * Stop background audio session and disconnect mesh/network if needed.
   */
  public stopBackgroundSession() {
    if (!this.platform.is('ios')) return;
    if (!this.isAudioSessionActive) return;

    this.ngZone.runOutsideAngular(() => {
      if (window.cordova && window.cordova.plugins && window.cordova.plugins.backgroundMode) {
        window.cordova.plugins.backgroundMode.disable();
        this.isAudioSessionActive = false;
        console.log('[IosBackgroundService] Background mode disabled');
      }
    });

    // Optionally, disconnect your mesh or WebSocket here
    // this.websocketService.disconnect();
    // this.webrtcMeshService.cleanupMesh();
  }

  public isBackgroundSessionActive(): boolean {
    return this.isAudioSessionActive;
  }
}
